export const hospitalAreas = [
    '.green-area',
    '.blue-area',
    '.pink-area',
    '.lime-area',
    '.light-blue-area',
    '.salmon-area',
    '.navy-area',
    '.orange-area',
    '.brown-area',
    '.gray-area',
    '.red-area',
];

export const hospitalMapData = {
    'green-area': {
        title: 'Jordan Tomaszewski',
        phone: '+48 691 630 496',
        email: '',
    },
    'blue-area': {
        title: 'Jakub Ochendal',
        phone: '+48 509 462 174',
        email: '',
    },
    'pink-area': {
        title: 'Karol Krośniewski',
        phone: '+48 501 332 885',
        email: '',
    },
    'lime-area': [
        {
            title: 'Mateusz Kaczmarczyk',
            phone: '+48 785 957 995',
            email: '',
        },
        {
            title: 'Rafał Olborski',
            phone: '+48 502 525 231',
            email: '',
        }
    ],
    'light-blue-area': {
        title: 'Maria Pela',
        phone: '+48 885 563 731',
        email: '',
    },
    'salmon-area': {
        title: 'Anna Więcław-Sierżęga',
        phone: '+48 885 852 964',
        email: '',
    },
    'navy-area': {
        title: 'Anna Czajkowska',
        phone: '+48 501 332 870',
        email: '',
    },
    'orange-area': {
        title: 'Magdalena Jasińska',
        phone: '+48 510 293 353',
        email: '',
    },
    'brown-area': {
        title: 'Michał Opioła',
        phone: '+48 507 142 992',
        email: '',
    },
    'gray-area': {
        title: 'Bartłomiej Metler',
        phone: '+48 885 552 804',
        email: '',
    },
    'red-area': {
        title: 'Krzysztof Bas',
        phone: '+48 501 489 043',
        email: '',
    },
};

export const defaultData = {
    title: '',
    phone: '',
    email: '',
    tooltip: 'contact.map.tooltipDefault',
};
